export type GapSize = 's' | 'm' | 'l' | 'max' | undefined | null | boolean;

export default function getGapSize(code: GapSize) {
  switch (code) {
    case 's':
      return '4px';
    case 'm':
    case true:
      return '8px';
    case 'l':
      return '16px';
    case 'max':
      return 'auto';
    default:
      return '';
  }
}
